import { render, staticRenderFns } from "./MoleculeEditionProductAssetsIncludedAssetsModal.vue?vue&type=template&id=5096f471&"
import script from "./MoleculeEditionProductAssetsIncludedAssetsModal.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductAssetsIncludedAssetsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports